import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityDireccionesGeograficaIDELoadFailure,
  entityDireccionesGeograficaIDELoadRequest,
  entityDireccionesGeograficaIDELoadSuccess
} from './entity-direcciones-geografica-ide.actions';
import { DireccionesGeograficaIDEService } from './direcciones-geografica-ide.service';

@Injectable()
export class DireccionesGeograficaIDEEffects {
  // load
  loadRequestDireccionesGeograficaIDE = createEffect(() =>
    this.actions$.pipe(
      ofType(entityDireccionesGeograficaIDELoadRequest),
      switchMap((action) =>
        this.direccionesGeograficaIDEService
          .getDireccionesGeograficaIDE(action.q)
          .pipe(
            map((items) => {
              // Filtro solo los de tipo calle
              //const itemsCalle = items.filter(i => i.type == 'CALLEyPORTAL');
              return entityDireccionesGeograficaIDELoadSuccess({
                items: items,
                mapa: action.mapa
              });
            }),
            catchError((error) =>
              of(entityDireccionesGeograficaIDELoadFailure({ error }))
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private direccionesGeograficaIDEService: DireccionesGeograficaIDEService
  ) {}
}
